import { createUploadLink } from 'apollo-upload-client'

import { REACT_APP_BACKEND_API } from 'utils/config'

export const httpLink = createUploadLink({
  uri: `${REACT_APP_BACKEND_API}/graphql`,
})
